




















import { Component, Vue } from 'vue-property-decorator';
import Logo from './Logo.vue';
import { getModule } from 'vuex-module-decorators';
import UrlStorageModule from '../../store/modules/urlStorage.module';

@Component({
  components: {
    'sch-logo': Logo,
  },
})
export default class MenuBar extends Vue {

  urlStorageStore: UrlStorageModule = getModule(UrlStorageModule);

  mounted() {
    this.urlStorageStore.loadUrls();
  }

}
